'use strict';
import Vue from 'vue'
//import contract from "@/components/proj/widgets/Contract";

/* eslint-disable */
export default {
    /**
     * 模块数据列表页面基础功能
     * @param uri 加载数据列表的 URI
     * @returns {*}
     */
    index: function (uri) {
        return {
            // 列表页面公共数据项
            data() {
                return {
                    phase: null,
                    loading: false,
                    pageResult: {items: [], total: 0},

                    // 检索、分页、排序条件条件
                    query: {
                        page: 1,
                        rowsPerPage: 25,
                        sortBy: null,
                        descending: null,
                        totalItems: null
                    },

                    // 检索框
                    form: {},
                }
            },

            // 路由进入前，组件未完成渲染，不可以使用 this
            beforeRouteEnter(to, from, next) {
                window.console.log("In Index beforeRouteEnter1");
                Vue.axios.get(uri, {params: window.xutil.toApiQuery(to.query)})
                    .then(
                        rsp => next(
                            vm => {
                                vm.prevent_xhr_data = true;

                                // 从地址栏回填检索条件
                                Object.assign(vm.form, to.query);
                                Object.assign(vm.query, to.query);

                                // 填列表数据
                                vm.pageResult = rsp.data;

                                window.console.log("vm.pageResult")
                                window.console.log(vm.pageResult)
                                vm.prevent_xhr_data = false;

                                vm.loading = false;
                            })
                    )
            },

            // 路由改变前，组件就已经渲染完成，可以使用 this
            beforeRouteUpdate(to, from, next) {
                window.console.log("In Index beforeRouteUpdate");
                window.console.log("混入此组件的父组件刷新时！")
                this.loading = true;
                Vue.axios.get(uri, {params: window.xutil.toApiQuery(to.query)})
                    .then(
                        rsp => {
                            this.pageResult = rsp.data;
                            this.loading = false;
                            next()
                        }
                    )
            },

            // 侦听器
            watch: {
                // 查询条件发生变化时，自动加载数据
                // query: {
                //   deep: true,
                //   handler: function (val, oldVal) {
                //     //console.log("In Watch query");
                //     if (val['totalItems'] === oldVal['totalItems']) {
                //       const qry = {};
                //       Object.keys(val).forEach(k => {
                //         if (k !== 'totalItems') {
                //           qry[k] = val[k];
                //         }
                //       });
                //       this.doRoute(qry);
                //       //console.log("In Watch query doRoute");
                //       //console.log(qry);
                //     }
                //   }
                // },
                "query.page": function () {
                    if (this.prevent_xhr_data)
                        this.prevent_xhr_data = false;
                    else
                        this.doRoute(this.query)
                },
                "query.rowsPerPage": function () {
                    if (this.prevent_xhr_data)
                        this.prevent_xhr_data = false;
                    else
                        this.doRoute(this.query)
                },
                "query.sortBy": function () {
                    if (this.prevent_xhr_data)
                        this.prevent_xhr_data = false;
                    else
                        this.doRoute(this.query)
                },
                "query.descending": function () {
                    if (this.prevent_xhr_data)
                        this.prevent_xhr_data = false;
                    else
                        this.doRoute(this.query)
                }

            },
            // 方法
            methods: {
                // 可以重载该函数，自定义URL参数解析
                urlPramas(urlQuery) {
                    return urlQuery;
                },

                onEditOk(item) {
                    //window.console.log("in mixin onEditOK");
                    //window.console.log(item);
                    if (item) {
                        if (!this.editDbid) {
                            this.pageResult.items.unshift(item);
                        } else {
                            const editIdx = this.pageResult.items.findIndex(v => v.dbid === item.dbid);
                            //下面此行为源代码，但当完成编辑修改后表格不进行回显，暂替换为下一行代码
                            //this.pageResult.items[editIdx] = window.xutil.clone(item);
                            // 使用 this.$set 更新数组元素
                            this.$set(this.pageResult.items, editIdx, window.xutil.clone(item));
                        }
                    }
                },
                onDeleOk(item) {
                    // window.console.log("onDeleOk")
                    if (item) {
                        const deleIdx = this.pageResult.items.findIndex(v => v.dbid === item.dbid);
                        this.pageResult.items.splice(deleIdx, 1);
                    }
                },
                clean(query) {
                    let q = {};
                    Object.keys(query).forEach(k => {
                        if (query[k] !== "" && query[k] !== null) {
                            q[k] = query[k];
                        }
                    });
                    return q;
                },
                // 根据查询（query）转到新的路由，以便加载数据
                doRoute(query) {
                    window.console.log("点击检索按钮！")
                    // 调用 clean 方法处理 query 参数（去除空格或特殊字符等）
                    const q = this.clean(query);
                    // 使用 vue-router 进行路由跳转，注意如果跳转到的路径和当前路径完全相同（包括query参数），Vue Router 默认不会重新触发导航
                    this.$router.push({
                        // 保持当前路径不变
                        path: this.$route.path,
                        // 设置新的 query 参数
                        // Object.assign({}, q) 创建一个新对象，复制 q 的所有属性
                        // 这里没有合并原有 query 参数，而是直接用新的 q 对象替换
                        // 注释掉的代码 Object.assign({}, this.$route.query, query) 是另一种实现方式：
                        // 它会合并当前路由的 query 和新的 query 参数
                        query: Object.assign({}, q), //Object.assign({}, this.$route.query, query)
                    });
                }
            }
        };

    },

    /**
     * 模块数据列表页面基础功能
     * @param uri 加载数据列表的 URI
     * @returns {*}
     */
    index_without_pagination: function (uri) {
        return {
            // 基础数据项
            data() {
                return {
                    loading: false,
                    items: []
                }
            },
            // 路由进入前，组件就未完成渲染，不可以使用 this
            beforeRouteEnter(to, from, next) {
                //console.log("In Index beforeRouteEnter");
                Vue.axios.get(uri, {params: window.xutil.toApiQuery(to.query)})
                    .then(
                        rsp => next(vm => {
                            vm.items = rsp.data;
                            vm.loading = false
                        })
                    )
            },

            // 路由改变前，组件就已经渲染完成，可以使用 this
            beforeRouteUpdate(to, from, next) {
                //console.log("In Index beforeRouteUpdate");
                Vue.axios.get(uri, {params: window.xutil.toApiQuery(to.query)})
                    .then(
                        rsp => {
                            this.items = rsp.data;
                            this.loading = false;
                            next()
                        }
                    )
            },

            // 侦听器
            watch: {
                // 查询条件发生变化时，自动加载数据
                query: {
                    deep: true,
                    handler: function (val, oldVal) {
                        //console.log("In Watch query");
                        if (val['totalItems'] === oldVal['totalItems']) {
                            const qry = {};
                            Object.keys(val).forEach(k => {
                                if (k !== 'totalItems') {
                                    qry[k] = val[k];
                                }
                            });
                            this.doRoute(qry);
                            //console.log("In Watch query doRoute");
                            //console.log(qry);
                        }
                    }
                },
            },
            // 方法
            methods: {
                onEditOk(item) {
                     //console.log("in mixin onEditOK");
                     //console.log(item);
                    if (item) {
                        if (!this.editDbid) {
                            this.items.unshift(item);
                        } else {
                            const editIdx = this.items.findIndex(v => v.dbid === item.dbid);
                            this.items[editIdx] = window.xutil.clone(item);
                        }
                    }
                },
                onDeleOk(item) {
                    if (item) {
                        const deleIdx = this.items.findIndex(v => v.dbid === item.dbid);
                        this.items.splice(deleIdx, 1);
                    }
                },
                // 根据查询（query）转到新的路由，以便加载数据
                doRoute(query) {
                    //console.log(query);
                    this.loading = true;
                    this.$router.push({
                        path: this.$route.path,
                        query: Object.assign({}, this.$route.query, query)
                    });
                }
            }
        };

    },

    /**
     * 模块查看页面基础功能
     * @param uri 加载数据列表的 URI
     * @returns {*}
     */
    view: function (uri) {
        return {
            props: ['value', 'dbid'],

            // 基础数据项
            data() {
                return {
                    loading: false,
                    fullscreen: false,
                    item: {}
                }
            },

            watch: {
                value(val) {
                    val && this.get()
                }
            },

            computed: {
                visible: {
                    // getter
                    get: function () {
                        return this.value;
                    },
                    // setter
                    set: function (nv) {
                        this.$emit('input', nv);
                    }
                }
            },

            methods: {
                /**
                 * **************************************************************
                 * 异步数据请求
                 */
                get() {
                    const vm = this;
                    this.loading = true;
                    this.axios.get(`${uri}/${this.dbid}`)
                        .then(rsp => {
                            // 填充对话框
                            window.console.log("View获取数据")
                            window.console.log(rsp.data)
                            vm.loading = false;
                            vm.item = rsp.data;
                            // for debug

                            if (this.afterGetData) {
                                this.afterGetData(rsp.data)
                            }
                        });
                }

            }
        };
    },

    /**
     * 模块查看页面基础功能
     * @param uri 加载数据列表的 URI
     * @returns {*}
     */
    viewClaim: function (uri) {
        return {
            props: ['value', 'dbid', 'flbh'],

            // 基础数据项
            data() {
                return {
                    loading: false,
                    fullscreen: false,
                    item: {}
                }
            },

            watch: {
                value(val) {
                    val && this.get()
                }
            },

            computed: {
                visible: {
                    // getter
                    get: function () {
                        return this.value;
                    },
                    // setter
                    set: function (nv) {
                        this.$emit('input', nv);
                    }
                }
            },

            methods: {
                /**
                 * **************************************************************
                 * 异步数据请求
                 */
                get() {
                    const vm = this;
                    this.loading = true;
                    let params = {};
                    if (this.flbh > 0) {
                        params["flbh"] = this.flbh;
                    }
                    this.axios.get(`${uri}/${this.dbid}`, {params: params})
                        .then(rsp => {
                            // 填充对话框
                            vm.loading = false;
                            vm.item = rsp.data;
                        });
                }

            }
        };
    },
    edit: function (uri) {
        return {
            props: ['value', 'dbid', "default"],

            // 基础数据项
            data() {
                return {
                    loading: false,
                    fullscreen: false,

                    item: null,
                    defaultItem: null,
                    freshItem: null,
                }
            },

            mounted() {
                // 组件创建完后获取数据，
                // 此时 data 已经被 observed 了
                // 复制默认的数据
                this.item = window.xutil.clone(this.freshItem);
                this.defaultItem = window.xutil.clone(this.freshItem);
            },

            watch: {
                value(val) {
                    //当父组件数据列表操作按钮编辑被点击时被触发，调用this.get()获取该条数据明细以填充form数据框
                    if (!val) return;
                    // window.console.log("in edit watch value");

                    this.$refs.formRef.reset();
                    this.item = Object.assign(window.xutil.clone(this.freshItem), this.default || {});
                    this.defaultItem = window.xutil.clone(this.freshItem);

                    this.dbid && this.dbid.length > 0 && this.get();
                }
            },

            computed: {
                visible: {
                    // getter
                    get: function () {
                        return this.value;
                    },
                    // setter
                    set: function (nv) {
                        this.$emit('input', nv);
                    }
                },
                title() {
                    return this.dbid ? '编辑' : '新建'
                }
            },

            methods: {
                // 保存响应函数
                onSave() {
                    const vm = this;
                    if (this.loading) return;
                    if (this.$refs.formRef.validate()) {
                        // 新建
                        window.console.log("新建")
                        if (!this.dbid || this.dbid.length === 0) {
                            // 以 POST 方式创建新记录
                            if (this.beforeSendData) this.beforeSendData(this.item);

                            vm.loading = true;
                            this.axios.post(uri, this.item)
                                .then(rsp => {
                                    vm.visible = false;
                                    vm.$emit('input', false);
                                    vm.$emit('ok', rsp.data);

                                    if (this.afterSave) this.afterSave();

                                    vm.loading = false;
                                })
                                .finally(ex => {
                                        vm.loading = false;
                                        if (ex) window.console.error(ex);
                                    }
                                )
                        }
                        //保存
                        else {
                            window.console.log("编辑")
                            // 获取修改的字段
                            const changes = window.xutil.changes(this.defaultItem, this.item);
                            //window.console.log("changes")
                            //window.console.log(changes)
                            // 有修改的字段，以 PUT 方式保存修改
                            if (Object.keys(changes).length > 0) {
                                vm.loading = true;

                                if (this.beforeSendData) this.beforeSendData(changes);

                                this.axios.put(`${uri}/${this.dbid}`, changes)
                                    .then(rsp => {
                                        //window.console.log("执行修改")
                                        vm.visible = false;
                                        //vm.$emit('input', false);
                                        vm.$emit('ok', rsp.data);
                                        //window.console.log("执行emit")
                                        if (this.afterSave) this.afterSave();
                                        vm.loading = false;
                                    })
                                    .finally(ex => {
                                            vm.loading = false;
                                            if (ex) window.console.error(ex);
                                        }
                                    )
                            }
                            // 关闭对话框
                            else {
                                vm.visible = false;
                                //vm.$emit('input', false);
                            }
                        }
                    }
                },
                get() {
                    const vm = this;

                    if (this.beforeGetData) {
                        this.beforeGetData()
                    }

                    vm.loading = true;
                    this.axios.get(`${uri}/${this.dbid}`)
                        .then(rsp => {
                            if (this.afterGetData) {
                                this.afterGetData(rsp.data)
                            }

                            // 填充编辑对话框
                            vm.item = rsp.data;
                            // 保存默认数据
                            vm.defaultItem = window.xutil.clone(vm.item);

                            vm.loading = false;
                        });
                }
            }
        };
    },

    edit_page: function (uri) {
        return {
            // 基础数据项
            data() {
                return {
                    loading: true,
                    dbid: null,
                    item: {}
                }
            },

            computed: {
                title() {
                    return this.dbid ? '编辑' : '新建'
                }
            },

            created() {
                // 组件创建完后获取数据，
                // 此时 data 已经被 observed 了
                // 复制默认的数据
                this.item = window.xutil.clone(this.freshItem);
                this.defaultItem = window.xutil.clone(this.freshItem);
                window.console.log("In mixin created")
            },


            // 路由进入前，组件就未完成渲染，不可以使用 this
            beforeRouteEnter(to, from, next) {
                window.console.log("In edit_page beforeRouteEnter");
                const dbid = to.query.dbid;

                if (dbid) {
                    Vue.axios.get(`${uri}/${dbid}`)
                        .then(
                            rsp => next(vm => {
                                vm.dbid = dbid;
                                vm.item = rsp.data;
                                // 保存默认数据
                                vm.defaultItem = window.xutil.clone(vm.item);
                                vm.loading = false
                            })
                        )
                } else {
                    next(vm => vm.loading = false);
                }
            },

            // 路由改变前，组件就已经渲染完成，可以使用 this
            beforeRouteUpdate(to, from, next) {
                window.console.log("In edit_page beforeRouteUpdate");

                const dbid = to.query.dbid;
                if (dbid) {
                    this.loading = true;
                    Vue.axios.get(`${uri}/${dbid}`)
                        .then(
                            rsp => {
                                this.dbid = dbid;
                                this.item = rsp.data;
                                // 保存默认数据
                                this.defaultItem = window.xutil.clone(this.item);
                                this.loading = false;
                                next()
                            }
                        )
                } else {
                    this.loading = false;
                    next();
                }
            },

            methods: {
                // 保存响应函数
                onSave() {
                    const vm = this;

                    if (this.loading) return;

                    if (this.$refs.formRef.validate()) {
                        if (this.beforeSave) this.beforeSave();
                        // 新建
                        if (!this.dbid) {
                            // 以 POST 方式创建新记录
                            vm.loading = true;
                            this.axios.post(uri, this.item)
                                .then(rsp => {
                                    vm.dbid = rsp.data.dbid;

                                    if (this.afterSave) this.afterSave();
                                }).finally(ex => {
                                    vm.loading = false;
                                    if (ex) window.console.error(ex);
                                }
                            )
                        }
                        //保存
                        else {
                            // 获取修改的字段
                            const changes = window.xutil.changes(this.defaultItem, this.item);

                            // 有修改的字段，以 PUT 方式保存修改
                            if (Object.keys(changes).length > 0) {
                                vm.loading = true;
                                this.axios.put(`${uri}/${this.dbid}`, changes)
                                    .then(() => {
                                        vm.loading = false;
                                        if (this.afterSave) this.afterSave();
                                    }).finally(ex => {
                                        vm.loading = false;
                                        window.console.log(ex);
                                    }
                                )
                            }
                        }
                    }
                }
            }
        };
    },

};
